import React, { useState } from "react";
import { contactAPI } from "../api/api";

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    // send to backend
    contactAPI.sendMessage(formData)
      .then((res) => {
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
        setTimeout(() => setSubmitted(false), 5000);
      })
      .catch((err) => {
        console.error('Contact send error:', err);
        setError(err.message || 'Failed to send message. Please try again later.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get In Touch</h1>
          <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
        </div>
      </section>

      {/* Contact Content Section */}
      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-wrapper">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <h2>Send us a Message</h2>
              
              {submitted && (
                <div className="contact-success">
                  <span className="success-icon">✓</span>
                  <h4>Message Sent Successfully!</h4>
                  <p>Thank you for contacting us. We'll get back to you soon.</p>
                </div>
              )}
              {error && (
                <div className="contact-error">
                  <h4>Error</h4>
                  <p>{error}</p>
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.email@example.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 (000) 000-0000"
                  />
                </div>

               
                <div className="form-group full-width">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us more about your inquiry..."
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="contact-submit-btn" disabled={loading}>{loading ? 'Sending...' : 'Send Message'}</button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-wrapper">
              <h2>Contact Information</h2>
              
              <div className="contact-info-group">
                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div className="info-content">
                    <h4>Office Location</h4>
                    <p>Kriva Bharat Private Limited<br />
                    Office No:2 Floor No:1st, Madhur Preet Building, Bhekrai Nagar, Phursungi 412308, Pune Saswad Road.</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div className="info-content">
                    <h4>Phone</h4>
                    <p><a href="tel:+919137947038">+91 9137 9470 38</a><br />
                    <a href="tel:+917030898428">+91 7030 8984 28</a></p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📧</div>
                  <div className="info-content">
                    <h4>Email</h4>
                    <p><a href="mailto:info@krivabharat.com">info@krivabharat.com</a><br />
                    <a href="mailto:sales@krivabharat.com">sales@krivabharat.com</a><br />
                    <a href="mailto:support@krivabharat.com">support@krivabharat.com</a></p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">🕐</div>
                  <div className="info-content">
                    <h4>Business Hours</h4>
                    <p>Monday - Saturday: 10:00 AM - 7:00 PM<br />
                    Sunday: Closed</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      {/* <section className="contact-faq">
        <div className="contact-container">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h4>How quickly will I receive a response?</h4>
              <p>We aim to respond to all inquiries within 24 hours during business days. For urgent matters, please call us directly.</p>
            </div>

            <div className="faq-item">
              <h4>What services do you offer?</h4>
              <p>We provide custom software development, cloud solutions, ERP systems, and technical support across various industries.</p>
            </div>

            <div className="faq-item">
              <h4>Do you provide support after implementation?</h4>
              <p>Yes! We provide 24/7 technical support and maintenance for all our implemented solutions.</p>
            </div>

            <div className="faq-item">
              <h4>Can you customize solutions for my business?</h4>
              <p>Absolutely! All our solutions are tailored to meet your specific business needs and requirements.</p>
            </div>

            <div className="faq-item">
              <h4>What is your pricing model?</h4>
              <p>Pricing varies based on project scope and complexity. Contact us for a custom quote based on your requirements.</p>
            </div>

            <div className="faq-item">
              <h4>How do I get started?</h4>
              <p>Simply fill out the contact form or give us a call. Our team will schedule a consultation to understand your needs.</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="contact-cta">
        <div className="contact-container">
          <h2>Can't find what you're looking for?</h2>
          <p>Our support team is here to help. Reach out to us and we'll assist you.</p>
          <a href="mailto:support@krivabharat.com" className="contact-cta-btn">Email Us</a>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
